import Resources from '../../../../helpers/resources';

export const SCHOOL_HAS_LIFETIME_DATA = 'SCHOOL_HAS_LIFETIME_DATA';

function getHasLifetimeData() {
    return (dispatch) =>
        Resources.hasLifetimeData
            .get()
            .send()
            .then((payload) => {
                if (payload.data === true) {
                    dispatch({
                        type: SCHOOL_HAS_LIFETIME_DATA,
                        payload: true
                    });
                } else {
                    dispatch({
                        type: SCHOOL_HAS_LIFETIME_DATA,
                        payload: false
                    });
                }
            });
}

export default {
    getHasLifetimeData
};



// WEBPACK FOOTER //
// ./components/report-filters/redux/has-lifetime-data/has-lifetime-data-actions.js